import { combineReducers } from "redux";

import project_type from "../features/admin/project_types/project_type/Slice";

import enquiry_form from "../features/admin/project_types/enquiry_forms/Slice";

import common from "../features/admin/common/Slice";

const project_types = combineReducers({
    project_type,
    enquiry_form,
    common
});

export default project_types;